// Packages:
import React, { memo } from "react";
import { useSelector } from "react-redux";

// Styles:
import { Body, Description, Field, NodeLabel, NodeWrapper, StyledHandle } from "../styles";
import BaseNode from "../BaseNode";
import { config } from "./config";
import useNodeStyles from "../../../../hooks/useNodeStyles";

// Functions:
const FormNode = ({ data }) => {
  // Constants:
  const { id, label, formName } = data;
  // State:
  const studio = useSelector((state) => state.studio);
  const isSelected = useSelector(
    (state) => state.studio.selectedNode?.id === id
  );

  const {computedLabelStyle,computedBodyStyle,computedWrapperStyle}=useNodeStyles({isSelected,config})

  // Return:
  return (
    <BaseNode data={data} config={config}>
      <NodeWrapper style={computedWrapperStyle} backgroundColor={'#FEFFFE'} borderColor={'#4F5450'}>
      {config.handleStyles.map((handle, index) => (
        <StyledHandle
            key={index}
            id={handle.properties.id}
            type={handle.properties.type}
            position={handle.properties.position}
            style={handle.style}
        />
        ))}
        <NodeLabel htmlFor="text" style={computedLabelStyle}>
          {label}
        </NodeLabel>
        <Body>
          <Description>
            <Field isActive={studio.selectedNode?.id === id} activeColor={'#282A28'} inActiveColor={'#4F5450'}>
              {formName.length === 0 ? (
                <span style={{ fontStyle: "italic", fontWeight: 400 }}>
                  Enter a form name...
                </span>
              ) : formName.length >= 30 ? (
                `${formName.slice(0, 25).trim()}..`
              ) : (
                formName
              )}
            </Field>
          </Description>
        </Body>
      </NodeWrapper>
    </BaseNode>
  );
};

// Exports:
export default memo(FormNode);
